"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLegend = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/dot/dot");
require("@/components/common/text/text");
/**
 * 차트가 그린 시리즈와 이름을 잇는 범례.
 * 점의 색은 mm-dot의 tone 규칙을 따르므로, 막대 같은 짝 차트와 같은 tone을 넘기면 색이 맞는다.
 */
let ChartLegend = class ChartLegend extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      ${this.items.map(item => this.renderItem(item))}
    `;
    }
    renderItem({ label, value, tone }) {
        return (0, lit_1.html) `
      <div class="item" role="listitem">
        <mm-dot tone=${tone}></mm-dot>
        <mm-text>${label}</mm-text>
        ${value
            ? (0, lit_1.html) `
              <mm-text class="value">${value}</mm-text>
            `
            : lit_1.nothing}
      </div>
    `;
    }
};
ChartLegend.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    .item {
      display: flex;
      align-items: center;
      gap: var(--space-2);
    }

    .value {
      margin-left: auto;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], ChartLegend.prototype, "items", void 0);
ChartLegend = __decorate([
    (0, decorators_js_1.customElement)('mm-chart-legend')
], ChartLegend);
exports.ChartLegend = ChartLegend;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnQtbGVnZW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2hhcnQtbGVnZW5kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsdUNBQW9DO0FBQ3BDLHlDQUFzQztBQVN0Qzs7O0dBR0c7QUFFSSxJQUFNLFdBQVcsR0FBakIsTUFBTSxXQUFZLFNBQVEsZ0JBQVU7SUFBcEM7O1FBa0JzQixVQUFLLEdBQXNCLEVBQUUsQ0FBQTtJQTBCMUQsQ0FBQztJQXhCQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUNuQyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDaEQsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVLENBQUMsRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBbUI7UUFDeEQsT0FBTyxJQUFBLFVBQUksRUFBQTs7dUJBRVEsSUFBSTttQkFDUixLQUFLO1VBQ2QsS0FBSztZQUNMLENBQUMsQ0FBQyxJQUFBLFVBQUksRUFBQTt1Q0FDdUIsS0FBSzthQUMvQjtZQUNILENBQUMsQ0FBQyxhQUFPOztLQUVkLENBQUE7SUFDSCxDQUFDOztBQTFDTSxrQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7O0dBZ0JsQixDQUFBO0FBQzBCO0lBQTFCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsQ0FBQzswQ0FBOEI7QUFsQjdDLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0E0Q3ZCO0FBNUNZLGtDQUFXIn0=